export default __webpack_public_path__ + "static/media/Chanel-Cake.ecfca790.jpg";